import { useScrollReveal } from '@/hooks/useScrollReveal';

const outcomes = [
  {
    id: 'cofounder-fracture',
    title: 'The Cofounder Fracture',
    body: "A two-person founding team with a working product and growing revenue. One founder was building. The other was selling. Neither trusted the other\u2019s priorities. They were three months from a split they couldn\u2019t see coming. I mapped the misalignment to three specific decisions where their assumptions diverged. We restructured role boundaries and decision authority in one session. They\u2019re still building together. The split never happened.",
  },
  {
    id: 'pitch-not-landing',
    title: "The Pitch That Wasn\u2019t Landing",
    body: "A solo founder with strong traction, raising a seed round. Twelve investor conversations, zero term sheets. The product was real. The metrics were real. The pitch was telling the wrong story \u2014 leading with technology instead of the market problem it solved. I restructured the narrative in one async cycle. The next three conversations converted.",
  },
  {
    id: 'equity-deadlock',
    title: 'The Equity Deadlock',
    body: "A three-person founding team with a strong product and early revenue. One cofounder held a significant equity stake but couldn\u2019t actively participate in day-to-day operations. Investors flagged it immediately \u2014 the cap table told a story that didn\u2019t match who was actually building the company. Nobody wanted to have the conversation. I facilitated it. We mapped each founder\u2019s actual contribution, future commitment, and role clarity against their ownership. Restructured the equity split with a vesting schedule that reflected reality, not the original handshake. The next investor conversation moved forward without the cap table objection.",
  },
];

const ProofBlock = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="proof-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3E4146' }}
    >
      <div className="content-narrow">
        <p className="section-label" data-testid="proof-label">Where this has worked</p>

        <div className="mt-10 space-y-12 md:space-y-16">
          {outcomes.map((o) => (
            <div key={o.id} data-testid={`proof-${o.id}`}>
              <h3 className="proof-title">{o.title}</h3>
              <p className="body-text-secondary mt-3">{o.body}</p>
            </div>
          ))}
        </div>

        <p className="founder-proof mt-16" data-testid="proof-founder-line">
          I&rsquo;ve been in the seat. Co-founder and CEO of Bottega Studios, a deep-tech company in real-time rendering and compression of volumetric and light-field content, whose technology assets were acquired by Snap Inc. in 2022. I learned that the founders who win aren&rsquo;t the ones who work the hardest &mdash; they&rsquo;re the ones who see and correct problems early. That&rsquo;s where I operate.
        </p>
      </div>
    </section>
  );
};

export default ProofBlock;
